<template>
  <div class="ob" :class="{ 'is-busy': !!loader }">
    <header class="ob-top">
      <span class="ob-mark">Smartbooks</span>
      <router-link class="ob-text" to="/auth/login">Sign in</router-link>
    </header>
    <main class="ob-main">
      <p class="ob-kicker">Password</p>
      <h1 class="ob-title">{{ title }}</h1>
      <p class="ob-lead">{{ lead }}</p>
      <p v-if="error" class="ob-error">{{ error }}</p>

      <form
        v-if="!token && !submitted"
        class="ob-stack"
        @submit.prevent="submitEmailForm"
      >
        <label class="ob-field">
          Email
          <input v-model="email" type="email" autocomplete="email" required />
        </label>
        <button class="ob-primary" type="submit" :disabled="!email">
          Send the reset link
        </button>
      </form>

      <div v-else-if="!token && submitted" class="ob-stack">
        <p class="ob-note">If that inbox is on a book, the link is on its way.</p>
        <router-link class="ob-ghost" tag="button" to="/auth/login">
          Back to sign in
        </router-link>
      </div>

      <form
        v-else-if="token && !submitted"
        class="ob-stack"
        autocomplete="off"
        @submit.prevent="submitResetPasswordForm"
      >
        <label class="ob-field">
          New password
          <input
            v-model="password"
            type="password"
            autocomplete="new-password"
            minlength="8"
            required
          />
        </label>
        <label class="ob-field">
          Confirm password
          <input
            v-model="confirmPassword"
            type="password"
            autocomplete="new-password"
            minlength="8"
            required
          />
        </label>
        <button class="ob-primary" type="submit" :disabled="!canReset">
          Save password
        </button>
      </form>

      <div v-else class="ob-stack">
        <p class="ob-note">Password saved. Sign in with the new one.</p>
        <router-link class="ob-primary" tag="button" to="/auth/login">
          Sign in
        </router-link>
      </div>
    </main>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { errorMessage } from "@/helpers/bookingSearch";

export default {
  data() {
    return {
      loader: null,
      email: "",
      submitted: false,
      password: "",
      confirmPassword: "",
      error: "",
      token: ""
    };
  },
  computed: {
    title() {
      if (this.token && this.submitted) return "You’re set.";
      if (this.token) return "Choose a new one.";
      if (this.submitted) return "Check your email.";
      return "Reset it.";
    },
    lead() {
      if (this.token && !this.submitted) return "Eight characters at least.";
      if (!this.token && !this.submitted) {
        return "We’ll send a link if this email has a book.";
      }
      return "";
    },
    canReset() {
      return this.password.length >= 8 && this.password === this.confirmPassword;
    }
  },
  methods: {
    ...mapActions(["sendPasswordResetEmail", "resetPassword"]),
    async submitEmailForm() {
      if (!this.email || this.loader) return;
      this.loader = true;
      this.error = "";
      try {
        await this.sendPasswordResetEmail({ email: this.email });
        this.submitted = true;
      } catch (error) {
        this.error = errorMessage(error, "Could not send the reset email.");
      } finally {
        this.loader = null;
      }
    },
    async submitResetPasswordForm() {
      if (!this.canReset || this.loader) return;
      this.loader = true;
      this.error = "";
      try {
        await this.resetPassword({
          token: decodeURIComponent(this.token),
          password: this.password
        });
        this.submitted = true;
      } catch (error) {
        this.error = errorMessage(error, "Could not save that password.");
        this.password = "";
        this.confirmPassword = "";
      } finally {
        this.loader = null;
      }
    }
  },
  created() {
    this.token = this.$route.query.token || "";
  }
};
</script>
